import { initSubRoutes } from '../../../../utils/router';

const RoutesModifierInformationsCompte = initSubRoutes({
    route: '/modifier-informations-compte/',
    subroutes: {},
    nom: 'Modifier les informations du compte',
});

export default RoutesModifierInformationsCompte;
